export default "__VITE_ASSET__hTlo3Ukj__"